import Base from '../../base';

export default class Default extends Base {
  init() {
    if(this.d.template.indexOf('page-press') == -1) return;

    this.bus.$on('vue/loaded', (d) => {this.loadImage();});
  }
  loadImage() {
    this.s.press.src = this.v.app.showImage( this.d.articles[0].image.src, this.s.press.resize );

    //Preload images
    var images = _.map(this.d.articles, (v) => {
      return this.v.app.showImage(v.image.src, this.s.press.resize);
    });

    this.s.app.preload = _.concat(this.s.app.preload, images);
  }
}